export default {
    supportedLngs: [
        'pt-PT',
        'en-US',
        'es-ES',
        'fr-FR',
        'pt-BR',
        'es-CL',
        'ca-ES',
    ],
    fallbackLng: 'pt-PT',
    debug: false,
};
